/**
 * returns an array of steps based on the provided bounds
 * and number of steps
 * @param {*} bounds
 * @param {*} numSteps
 */
export const getStepValues = (bounds, numSteps = 10) => {
  const stepAmount = (bounds[1] - bounds[0]) / numSteps
  return new Array(numSteps + 1)
    .fill()
    .map((v, i) => bounds[0] + i * stepAmount)
}

export const cloneObject = (obj) =>
  JSON.parse(JSON.stringify(obj))

export const getDefaultZoom = (bounds) => {
  const steps = getStepValues(bounds, 10)
  return steps[3]
}

/**
 * HACK: Sometimes an error occurs trying to release pointers, but it doesn't
 * break anything.  This wraps handlers in a try / catch block so
 * when the error happens it is silently logged to the console.
 */
export const wrapHandlers = (handlers) =>
  Object.keys(handlers).reduce((obj, key) => {
    return {
      ...obj,
      [key]: (...args) => {
        try {
          handlers[key](...args)
        } catch (e) {
          console.warn(e)
        }
      }
    }
  }, {})
